// extracted by mini-css-extract-plugin
module.exports = {"loading-icon":"Button_loading-icon__0XLDM","spin":"Button_spin__ee0yM"};